// src/AboutUs.js

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FanFacetCol from "../components/FanFacetCol";
import { IMAGES } from "../assets/img/ImageIndex";
import WhyUsArea from "../components/WhyUsArea";

function AboutUs() {
  useEffect(() => {
    // Set document title and meta tags
    document.title = 'About EnvoCapital | Trusted Business Funding Company USA';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn how EnvoCapital supports entrepreneurs with practical small business funding solutions. We focus on responsible financing, transparency, and long-term business growth.');
    }
  }, []);

  return (
    <div className="loan-program-page">
        <div className="page-banner-area bg-gray2">
            <div className="container mw-1380">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="page-banner-content">
                            <ul className="ps-0 list-unstyled breadcrumbs">
                                <li><Link to="/">Home</Link></li>
                                <li>About Us</li>
                            </ul>
                            <h1>Business Growth Architects: Turning Ambition into Opportunity with Smart Financing At EnvoCapital.</h1>
                            <p>From evaluation to approval, our mission is to provide exceptional service while maximizing your savings. Every solution is fully customized, and we identify the right funding program and secure the best terms to fuel your company’s growth.</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="page-banner-img text-center text-lg-end position-relative z-1">
                            <img src={IMAGES.bannerImg6} className="img" alt="banner-img"/>
                            <img src={IMAGES.shape7} className="shape shape-7" alt="Shape1"/>
                            <img src={IMAGES.shape8} className="shape shape-8" alt="Shape2"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="about-us-area pt-105 pb-105">
            <div className="container mw-1380">
                <div className="about-us-content">
                    <p>At EnvoCapital, we genuinely care about what’s best for your business. From application to approval, our goal is to provide exceptional service while helping you save more. We offer fully customized business loan solutions, finding the right program and most favorable terms for your needs. Our success is built on the trust of our clients and partners, who rely on us every day to guide and support them through the business loan process.</p>
                    <div className="row align-items-center">
                        <div className="col-lg-5 text-center text-lg-start">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-sm-6">
                                    <div className="about-img-1 mb-4 mb-sm-0">
                                        <img decoding="async" src={IMAGES.about1} alt="about1"/>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6">
                                    <div className="about-img-2 mb-4 mb-sm-0">
                                        <img decoding="async" src={IMAGES.about2} alt="about2"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="ms-lg-5 ps-lg-3">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-6">
                                        <FanFacetCol count={'78%'} title="Business from Referrals" duration={1000}/>
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                        <FanFacetCol count={'45+'} title="Minute Verbal Commitment" duration={1000}/>
                                    </div>
                                </div>
                                <div className="popular-clients-wrap mb-4 mb-lg-0">
                                    <div className="row align-items-center">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="why-us-area pt-130">
            <WhyUsArea/>
        </div>
        <div className="fan-facet-area pt-130 pb-105">
            <div className="container mw-1380">
                <div className="d-sm-flex justify-content-lg-between justify-content-center gap-3 gap-lg-0 align-items-center flex-wrap">
                    <FanFacetCol count={'684+'} title="Businesses Empowered" duration={1000}/>
                    <FanFacetCol count={'10K+'} title="Business Loans Completed" duration={1000}/>
                    <FanFacetCol count={'10+'} title="Years of Excellence" duration={1000}/>
                    <FanFacetCol count={'100K+'} title="Successful Partnerships Worldwide" duration={1000}/>
                </div>
            </div>
        </div>        
    </div>
  );
}

export default AboutUs;
